import React from "react";

function Title(){
    return (
        <h1>ToDo App</h1>
    )
}

export { Title }


// WEBPACK FOOTER //
// ./src/Title.js